import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=0fa5927d&scoped=true"
import script from "./errorModal.vue?vue&type=script&lang=js"
export * from "./errorModal.vue?vue&type=script&lang=js"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=0fa5927d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa5927d",
  null
  
)

export default component.exports